// extracted by mini-css-extract-plugin
module.exports = {"ionItem":"style_ionItem__16PZ4"};